import { render } from "./InputDrawPad.vue?vue&type=template&id=4017c8c4"
import script from "./InputDrawPad.vue?vue&type=script&lang=js"
export * from "./InputDrawPad.vue?vue&type=script&lang=js"
script.render = render

export default script